<template>
	<v-list-item :id="'newsletter' + data.id" two-line @click="openUrl()">
			<v-list-item-content>
			<v-list-item-subtitle class="icoev-date-text" style="margin: 0 0 10px 0;">{{ data.fecha }}</v-list-item-subtitle>
			<v-list-item-title class="primary--text mb-1 icoev-item-title">{{ data.titulo }}</v-list-item-title>
		</v-list-item-content>
	</v-list-item>
</template>

<script>
import BaseModule from "./BaseModule";
import cordova from "../../api/cordova";
import discovery from '../../discovery';

export default {
	name: 'NewsletterItem',
	mixins: [ BaseModule ],
	props: [ 'data' ],
	data() {
		return {
			openUrl() {
				if (this.$store.state.icoev.device.platform == 'browser') {
					window.open(this.getRedirectUrl(this.data.link));
					return;
				}
				
				cordova.openUrl(encodeURI(this.getRedirectUrl(this.data.link)));
				//this.$emit('open-external-content', 'Detalle newsletter', this.data.link);
			},
			getRedirectUrl(target) {
				return discovery.icoev_service_url+"users/externalRedirect/"+this.$store.state.icoev.redirectToken+"?t="+target;
			},
		}
	}
}
</script>